export default __webpack_public_path__ + "static/media/518.20d3178e.png";